import { Route, Routes } from 'react-router-dom';

import Purchase from './Purchase';
import IncomeDetail from './IncomeDetail';
import PrimaryDetail from './PrimaryDetail';
import PurchaseApplicationSummary from './PurchaseApplicationSummary';
import PurchaseResultsDashboard from './PurchaseResultsDashboard';
import FactFind from './FactFind';
export const PurchaseRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Purchase />} />
      <Route path="summary/:id" element={<PurchaseApplicationSummary />} />
      <Route path="result/:id" element={<PurchaseResultsDashboard />} />
      <Route path="step/primary-detail/:id?" element={<PrimaryDetail />} />
      <Route path="fact-find/:step/:id" element={<FactFind />} />
      <Route
        path="step/income-detail/:id/:update?"
        element={<IncomeDetail />}
      />
    </Routes>
  );
};
